import type { FC } from "react";

import { parseSmartLink } from "../../parseSmartLink.tsx";
import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const LinkifiedCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  return <TableCell>{parseSmartLink(props.value)}</TableCell>;
};

export default LinkifiedCell;
